// Nhãn màu cho KHUNG (thẻ .card có tiêu đề h3) ở MỌI trang Boss (05/10/2026). Người dùng: "các mảng phần này nên cho nhãn đánh dấu gì đó rõ
// ràng, nhìn không rõ được chia ra lại cứ tưởng 1 mảng … khắp các trang khác nữa". Một bộ theo dõi CHUNG (như cuon-bang.ts), không sửa từng trang:
//  · mỗi khung có tiêu đề nhận data-khung="0..7" → CSS chọn màu viền trái + dải tiêu đề (style.css, mục "Khung có nhãn màu");
//  · màu theo TÊN khung (cùng tên → cùng màu mọi trang/mọi lần vẽ) nhưng KHÁC màu với 3 khung đứng trước theo thứ tự trang, để khung ngay phía
//    trên (kể cả trong lưới 2–3 cột) không bao giờ trùng màu.
// Khung vẽ lại / đổi trang → MutationObserver trên #main.

export const SO_MAU_KHUNG = 8;
const SO_TRANH = 3;

/** Khoá so tên: bỏ phần trong ngoặc và chữ số (đếm, phiên bản…), gộp khoảng trắng, chữ thường. */
export function khoaTenKhung(ten: string): string {
  return ten.slice(0, 200).replace(/\([^)]*\)/g, " ").replace(/\d+/g, " ").replace(/\s+/g, " ").trim().toLowerCase();
}

function bam(s: string): number {
  let x = 2166136261;
  for (let i = 0; i < s.length; i++) { x ^= s.charCodeAt(i); x = Math.imul(x, 16777619); }
  return x >>> 0;
}

/** Chỉ số màu cho từng khung theo thứ tự trang. Thuần — gọi lại cho cùng kết quả. */
export function chonMauKhung(tens: readonly string[]): number[] {
  const ra: number[] = [];
  for (const ten of tens) {
    const truoc = ra.slice(-SO_TRANH);
    let m = bam(khoaTenKhung(ten)) % SO_MAU_KHUNG;
    while (truoc.includes(m)) m = (m + 1) % SO_MAU_KHUNG;
    ra.push(m);
  }
  return ra;
}

/** Tiêu đề của khung: h3 đứng đầu thẻ, hoặc HÀNG đầu thẻ (tiêu đề + nút, vd "Tần suất chạy" + "Thêm khung giờ") có h3 đứng đầu. */
function tieuDe(el: Element): { dau: HTMLElement; h3: HTMLElement } | null {
  const f = el.firstElementChild;
  if (!(f instanceof HTMLElement)) return null;
  if (f.tagName === "H3") return { dau: f, h3: f };
  const g = f.firstElementChild;
  return g instanceof HTMLElement && g.tagName === "H3" ? { dau: f, h3: g } : null;
}

function toMau(goc: ParentNode): void {
  const ds: { the: HTMLElement; dau: HTMLElement; h3: HTMLElement }[] = [];
  for (const c of goc.querySelectorAll<HTMLElement>(".card")) { const t = tieuDe(c); if (t) ds.push({ the: c, ...t }); }
  const mau = chonMauKhung(ds.map((k) => k.h3.textContent ?? ""));
  ds.forEach((k, i) => {
    const v = String(mau[i]);
    if (k.the.dataset.khung !== v) k.the.dataset.khung = v;
  });
}

let daBat = false;
/** Bật một lần lúc khởi động (app.ts). */
export function batMauKhung(goc: HTMLElement | null = document.getElementById("main")): void {
  if (daBat || !goc) return;
  daBat = true;
  // Gán màu NGAY trong lượt MutationObserver (vi tác vụ, trước khi trình duyệt vẽ) → không có khung hình nào thẻ mới hiện màu xám rồi mới đổi.
  // Bố cục không phụ thuộc data-khung (style.css dùng :has) nên thẻ không nhích. Chỉ theo dõi thêm/bớt nút + đổi chữ (không theo dõi thuộc
  // tính → gán data-khung không tự kích lại).
  new MutationObserver(() => toMau(goc)).observe(goc, { childList: true, subtree: true, characterData: true });
  toMau(goc);
}
